module.exports = __webpack_public_path__ + "static/media/settings-24px.83d38c97.svg";